import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { Crumb } from "@/lib/seo";

/**
 * Visible breadcrumb trail. `trail` excludes Home (added automatically) and
 * ends with the current page, which renders as plain text.
 */
export function Breadcrumbs({ trail }: { trail: Crumb[] }) {
  const { t } = useTranslation("chrome");
  const items = [{ name: t("breadcrumb.home"), path: "/" }, ...trail];

  return (
    <nav aria-label={t("breadcrumb.ariaLabel")} className="mx-auto max-w-6xl px-5 pt-5">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground sm:text-sm">
        {items.map((crumb, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-1.5">
              {i > 0 && (
                <ChevronRight aria-hidden className="size-3.5 shrink-0 opacity-60" />
              )}
              {isLast ? (
                <span aria-current="page" className="font-semibold text-primary">
                  {crumb.name}
                </span>
              ) : (
                <Link
                  to={crumb.path}
                  className="transition-colors hover:text-accent hover:underline"
                >
                  {crumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
